// Swedish translation helpers for admin order displays
export const STATUS_LABELS_SV = {
  paid: "Betald",
  awaiting_invoice: "Väntar faktura",
  invoice_sent: "Faktura skickad",
  initiated: "Påbörjad",
  pending: "Pågående",
};

export const METHOD_LABELS_SV = {
  card: "Kort",
  invoice: "Faktura",
};

export const AVAILABILITY_LABELS_SV = {
  Available: "Tillgängligt",
  Limited: "Begränsat",
  "Very Limited": "Mycket begränsat",
  "2 remaining": "2 kvar",
  "3 remaining": "3 kvar",
  "Sold Out": "Slutsålt",
  "Coming Soon": "Kommer snart",
};

export const statusSv = (k) => STATUS_LABELS_SV[k] || k;
export const methodSv = (k) => METHOD_LABELS_SV[k] || k;
export const availabilitySv = (k) => AVAILABILITY_LABELS_SV[k] || k;

// Tailwind class for status badge
export const statusBadgeCls = (status) => {
  if (status === "paid") return "border-emerald-500/30 text-emerald-400 bg-emerald-500/5";
  if (status === "awaiting_invoice") return "border-amber-500/30 text-amber-400 bg-amber-500/5";
  return "border-white/20 text-white/50";
};

// Tailwind class for payment method badge
export const methodBadgeCls = (method) =>
  method === "card" ? "border-blue-500/30 text-blue-400" : "border-amber-500/30 text-amber-400";
